import React from "react";
import Text from "components/ui/Text";
import { Button } from "components/ui/Button";
import { BizContainer, BizInfoContainer, BizInfoWrap, BizInfo, BizButtonContainer, BizImage } from "./BizContainer";

interface BizInfoCardProps {
  iconSrc: string;
  iconAlt: string;
  title: string;
  address: string;
  phone: string;
  buttons: Array<{
    text: string;
    variant:
      | "default"
      | "primary"
      | "secondary"
      | "black"
      | "white"
      | "outline"
      | "disabled"
      | "secondaryLight"
      | "error"
      | "primaryWhite";
    onClick?: () => void;
  }>;
}

export const BizInfoCard: React.FC<BizInfoCardProps> = ({ iconSrc, iconAlt, title, address, phone, buttons }) => {
  return (
      <BizInfoContainer>
        <BizInfoWrap>
          <BizImage src={iconSrc} alt={iconAlt} />
          <BizInfo>
            <Text fontSize={17} fontWeight={600} color="#1A1A1E">
              {title}
            </Text>
            <Text fontSize={13} fontWeight={400} color="#51525C" textEllipsis={true}>
              {address}
            </Text>
            <Text fontSize={13} fontWeight={400} color="#51525C">
              {phone}
            </Text>
          </BizInfo>
        </BizInfoWrap>

        <BizButtonContainer>
          {buttons.map((button, index) => (
            <Button key={index} variant={button.variant} size="xs" padding="10px 14px" onClick={button.onClick}>
              {button.text}
            </Button>
          ))}
        </BizButtonContainer>
      </BizInfoContainer>
  );
};
